import BaseLayout from "../Layout/BaseLayout";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { useTranslation } from "react-i18next";
import { Divider } from "@nextui-org/react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function AboutPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <BaseLayout>
      <Helmet>
        <title>{t("menuaboutUs")}</title>
        <meta name="description" content={t("menuaboutUs")} />
      </Helmet>
      <Swiper
        dir="rtl"
        className="h-[25rem] xl:h-[40rem]   "
        loop={true}
        navigation={true}
        modules={[Navigation]}
      >
        <div className="text-white  text-lg  xl:text-3xl absolute top-[65%] lg:top-[40%]   left-[50%]  lg:left-[70%] transform -translate-x-1/2 -translate-y-1/2 z-10  flex flex-col gap-1 items-center">
          {t("menuaboutUs")}
          <Divider className=" w-full h-1 bg-red-600 my-1  " />
          <div
            className={`bg-white px-5 py-2 rounded-md   flex justify-center items-center w-full whitespace-nowrap ${
              localStorage.getItem("lng") === "fa"
                ? "rtl"
                : localStorage.getItem("lng") === "en"
                ? "ltr flex-row-reverse lg:flex-row"
                : ""
            }`}
          >
            <div
              className="text-sm text-gray-600 cursor-pointer "
              onClick={() => navigate("/")}
            >
              {t("menuHome")}
            </div>
            <span className="px-2  text-black">/</span>
            <div>
              <span className="text-[15px] font-bold text-black">
                {t("menuaboutUs")}
              </span>
            </div>
          </div>{" "}
        </div>
        <SwiperSlide key={1}>
          <img
            src="/Assets/Images/aboutUs_193069.jpg"
            className="w-full h-[80%] object-cover "
            alt="1"
          />
          <div className="absolute top-0  w-full h-[80%] bg-gradient-to-r from-primary-900 to-transparent opacity-90" />
        </SwiperSlide>
      </Swiper>
      <div className="flex flex-col  justify-center leading-loose p-5 xl:w-[60%] m-auto relative -top-[12rem]  mt-24  ">
        <div className=" font-bold text-2xl  sm:text-4xl  text-primary-800 py-5">
          {t("team")}
          <p className="text-lg font-normal mt-1 text-black">
            {t("teamDetail")}
          </p>
        </div>
        <div className=" font-bold text-2xl  text-primary-800 py-5 ">
          <h1>{t("Varioushonors")}</h1>
          <p className="text-lg font-normal mt-1 text-black">
            {t("VarioushonorsDetail")}
          </p>
        </div>
        <div className=" font-bold text-2xl text-primary-800 py-5">
          <h1>{t("HighQualityRawMaterials")}</h1>
          <p className="text-lg font-normal mt-1 text-black">
            {t("HighQualityRawMaterialsDetail")}
          </p>
        </div>
        <div className=" font-bold text-2xl text-primary-800 py-5">
          <h1>{t("ProductionVolumeAndSpeed")}</h1>
          <p className="text-lg font-normal mt-1 text-black">
            {t("ProductionVolumeAndSpeedDetail")}
          </p>
        </div>
        <div className=" font-bold text-2xl text-primary-800 py-5">
          <h1>{t("BeingExported")}</h1>
          <p className="text-lg font-normal mt-1 text-black">
            {t("BeingExportedDetail")}
          </p>
        </div>
        <div className=" font-bold text-2xl text-primary-800 py-5">
          <h1>{t("HighVarietyOfProducts")}</h1>
          <p className="text-lg font-normal mt-1 text-black">
            {t("HighVarietyOfProductsDetail")}
          </p>
        </div>
        <div className=" font-normal text-xl  py-5 -mb-52">
          {t("AbutDetail")}
        </div>
      </div>
      <div className="bg-gradient-to-tl from-primary-800 opacity-95 ">
        <div className="flex flex-col sm:flex-row justify-center gap-10  w-72 lg:w-96 m-auto p-10  ">
          <img src="/Assets/Images/photo 1.jpg" className="  " alt="1" />
          <img src="/Assets/Images/photo 2.jpg" className=" " alt="1" />
        </div>
      </div>
    </BaseLayout>
  );
}
